import React, {useEffect, useState} from 'react'
import './ChangeTimePeriodModal.scss'
import {useDispatch, useSelector} from "react-redux";
import {isDistributorAdmin} from "../helpers/helpers";
import {
    getSensorDetailsError, getSensors,
    getSensorsUpdateTimes, getSensorTypesForTimeUpdate, updateAllSensorsMeasurementTypes,
    updateSensorMeasurementTime
} from "../store/actions/sensorsActions";
import ErrorModal from "./_common/ErrorModal";

const selector = state => {
    const { language, disableButtons, sensors } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: sensors.selected,
        updateTimes: sensors.updateTimes,
        error: sensors.error,
        sensorUpdateTypes: sensors.sensorUpdateTypes
    }
};

const ChangeTimePeriodModal = props => {
    const { t, selected, updateTimes,sensorUpdateTypes, error} = useSelector(selector);
    const {closeMethod, globalConfiguration} = props;
    const [showOptions, setShowOptions] = useState(false)
    const [showTypeOptions, setTypeOptions] = useState(false)
    const [selectedTimePeriod, setSelectedTimePeriod] = useState(null)
    const [selectedUpdateType, setSelectedUpdateType] = useState(null)

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSensorsUpdateTimes())
        if(globalConfiguration) {
            dispatch(getSensorTypesForTimeUpdate())
        }
    }, [])

    const handleChangeUploadTimeClick = () => {
        dispatch(updateSensorMeasurementTime(selected.sensor.id, selectedTimePeriod))
        closeMethod()
    }

    const handleGlobalConfiguration = () => {
        dispatch(updateAllSensorsMeasurementTypes(selectedUpdateType, selectedTimePeriod))
        dispatch(getSensors(1, 10, 'ALL', 0, '', null, null, null));
        closeMethod()
        dispatch(getSensorDetailsError(''))
    }


    return (
        <div className="timeChangeContainer">
            {globalConfiguration
                ?   <div className='timeHeader'>{t.gettext('Configure time reporting')}</div>
                :    <div className='timeHeader'>{t.gettext('Update measurements upload time for sensor')}{' '}{selected.sensor && selected.sensor.name ? selected.sensor.name : ''}</div>
            }
            {globalConfiguration && (
                <div className='fieldFormItem'>
                    <label className='sensorModalFormLabel'>
                        {t.gettext('Sensor Type')}
                    </label>
                    <div
                        className='sensorModalFormSelect'
                        onClick={() => setTypeOptions(!showTypeOptions)}
                    >
                        <div className='sensorModalFormSelectText'>
                            {selectedUpdateType}
                        </div>
                        <i className="material-icons dropDownIcon">
                            {showTypeOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                        </i>
                        {showTypeOptions &&
                            <div className='sensorModalFormSelectOptions'>
                                {sensorUpdateTypes.map((item, index) => (
                                    <div
                                        className='sensorModalFormSelectOption'
                                        key={index}
                                        onClick={() => setSelectedUpdateType(item)}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                </div>
            )}
            <div className='fieldFormItem'>
                <label className='sensorModalFormLabel'>
                    {t.gettext('Upload Time')}
                </label>
                <div
                    className='sensorModalFormSelect'
                    onClick={() => setShowOptions(!showOptions)}
                >
                    <div className='sensorModalFormSelectText'>
                        {selectedTimePeriod}
                    </div>
                    <i className="material-icons dropDownIcon">
                        {showOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                    </i>
                    {showOptions &&
                        <div className='sensorModalFormSelectOptions'>
                            {updateTimes.map((item, index) => (
                                <div
                                    className='sensorModalFormSelectOption'
                                    key={index}
                                    onClick={() => setSelectedTimePeriod(item)}
                                >
                                    {item}
                                </div>
                            ))}
                        </div>
                    }
                </div>
            </div>
            <div className="timeBtnWrapper">
                <button
                    className='changeTimeBtn saveTimeBtn'
                    onClick={e => {
                        e.preventDefault();
                        globalConfiguration ? handleGlobalConfiguration() : handleChangeUploadTimeClick()
                    }}
                    disabled={globalConfiguration ? (!selectedTimePeriod || !selectedUpdateType) : !selectedTimePeriod}
                >
                    {t.gettext('Update')}
                </button>
                <button
                    className='changeTimeBtn cancelTimeBtn'
                    onClick={e => {
                        e.preventDefault();
                        closeMethod()
                    }}
                >
                    {t.gettext('Cancel')}
                </button>

            </div>
            {error &&
                <ErrorModal
                    error={error}
                    closeMethod={() => dispatch(getSensorDetailsError(''))}
                />
            }
        </div>
    )

}

export default ChangeTimePeriodModal
